var map = {
	"./pic1.webp": 6740,
	"./pic10.webp": 8868,
	"./pic2.webp": 4225,
	"./pic3.webp": 8902,
	"./pic4.webp": 6043,
	"./pic5.webp": 2312,
	"./pic6.webp": 8421,
	"./pic7.webp": 4154,
	"./pic8.webp": 9791,
	"./pic9.webp": 5500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 276;